export class FreigebenSendEmailFailedNotification extends Error {
    
}